import { api } from '@/api'
import { useQuery } from '@tanstack/react-query'
import { User } from './models'

export const CACHE_KEY_USE_FETCH_USER = 'useFetchUser'

export const useFetchUser = (isEnabled: boolean) => {
  return useQuery({
    enabled: isEnabled,
    queryKey: [CACHE_KEY_USE_FETCH_USER],
    queryFn: () => api.get<User>('/user')
  })
}
